import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Umbrella icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Umbrella } from '@sravni/design-system-icons'
 *
 * <Umbrella />
 * ```
 */
var Umbrella = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Umbrella", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10 2.5v.833M6.667 15.152v.842c0 .916.746 1.659 1.666 1.659.921 0 1.667-.743 1.667-1.659v-6.18", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M7.5 10.813c1.38-1.333 3.62-1.333 5 0 1.38-1.333 3.62-1.333 5 0a7.5 7.5 0 0 0-15 0c1.38-1.333 3.62-1.333 5 0Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Umbrella };
//# sourceMappingURL=Umbrella.js.map
